import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Snackbar,
} from "@material-ui/core";
import axios from "axios";
import { Field, Form, Formik } from "formik";
import React, { useState } from "react";
import Alert from "../../../ui/alert";
import { Textfield } from "../../../ui/form_fields";

const initialValues = {
  email: "",
};

const RecoveryPasswordFormModal = ({ open, onClose, onSuccess }) => {
  const [error, setError] = useState(null);

  const handleSubmit = async (values) => {
    try {
      await axios.post("/auth/password", values);
      onSuccess.call(null);
    } catch ({ response, message }) {
      const { data, status } = response;

      if (status === 404) {
        onSuccess.call(null);
      } else {
        setError(data.errors?.join(", ") || message);
      }
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>Esqueceu sua senha?</DialogTitle>

      <Formik initialValues={initialValues} onSubmit={handleSubmit}>
        {({ isSubmitting, dirty }) => (
          <Form>
            <DialogContent>
              <Field
                isRequired={true}
                name="email"
                type="email"
                label="Email"
                component={Textfield}
              />
            </DialogContent>

            <DialogActions>
              <Button onClick={onClose} disabled={isSubmitting}>
                Cancelar
              </Button>

              <Button
                type="submit"
                color="primary"
                disabled={isSubmitting || !dirty}
              >
                Enviar email de recuperação de senha
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>

      <Snackbar
        open={!!error}
        autoHideDuration={5000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setError(null)}
      >
        <Alert severity="error" message={error} />
      </Snackbar>
    </Dialog>
  );
};

export default RecoveryPasswordFormModal;
